// Action types and interfaces

export type ActionType =
  | 'apply_label'
  | 'remove_label'
  | 'skip_inbox'
  | 'send_to_inbox'
  | 'mark_as_read'
  | 'mark_as_unread'
  | 'mark_as_important'
  | 'mark_as_unimportant'
  | 'mark_as_spam'
  | 'mark_as_not_spam'
  | 'add_to_blocklist';

export interface Action {
  id: number;
  actionType: ActionType;
  order: number;
  parameters: Record<string, any>;
}

// Action type metadata
export interface ActionTypeMetadata {
  value: ActionType;
  label: string;
  description: string;
  parameters: ActionParameter[];
}

export interface ActionParameter {
  name: string;
  type: 'text' | 'email';
  required: boolean;
  placeholder?: string;
  validation?: {
    pattern?: string;
    message?: string;
  };
}

export const ACTION_TYPES: ActionTypeMetadata[] = [
  {
    value: 'apply_label',
    label: 'Apply Label',
    description: 'Add a Gmail label to the email',
    parameters: [
      {
        name: 'label_name',
        type: 'text',
        required: true,
        placeholder: 'e.g., Newsletters',
      },
    ],
  },
  {
    value: 'remove_label',
    label: 'Remove Label',
    description: 'Remove a Gmail label from the email',
    parameters: [
      {
        name: 'label_name',
        type: 'text',
        required: true,
        placeholder: 'e.g., Newsletters',
      },
    ],
  },
  {
    value: 'skip_inbox',
    label: 'Skip Inbox',
    description: 'Archive the email (skip inbox)',
    parameters: [],
  },
  {
    value: 'send_to_inbox',
    label: 'Send to Inbox',
    description: 'Move the email back to inbox',
    parameters: [],
  },
  {
    value: 'mark_as_read',
    label: 'Mark as Read',
    description: 'Mark the email as read',
    parameters: [],
  },
  {
    value: 'mark_as_unread',
    label: 'Mark as Unread',
    description: 'Mark the email as unread',
    parameters: [],
  },
  {
    value: 'mark_as_important',
    label: 'Mark as Important',
    description: 'Mark the email as important',
    parameters: [],
  },
  {
    value: 'mark_as_unimportant',
    label: 'Mark as Unimportant',
    description: 'Remove important mark from the email',
    parameters: [],
  },
  {
    value: 'mark_as_spam',
    label: 'Mark as Spam',
    description: 'Move the email to spam folder',
    parameters: [],
  },
  {
    value: 'mark_as_not_spam',
    label: 'Mark as Not Spam',
    description: 'Remove the email from spam folder',
    parameters: [],
  },
  {
    value: 'add_to_blocklist',
    label: 'Add the sender\'s email to your block list.',
    description: 'Add sender email to blocklist',
    parameters: [],
  },
];

// Helper functions
export function getActionTypeMetadata(type: ActionType): ActionTypeMetadata | undefined {
  return ACTION_TYPES.find((at) => at.value === type);
}

export function generateActionId(): string {
  return `action_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
